var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sellerMenu" },
    [
      _c(
        "el-menu",
        {
          staticClass: "menu",
          attrs: {
            "background-color": "#fff",
            "text-color": "#333",
            "active-text-color": "#ff0023",
            "unique-opened": true,
            "collapse-transition": false
          }
        },
        [
          _vm._l(_vm.menuList, function(menu, index) {
            return [
              menu.children && menu.children.length > 0
                ? _c(
                    "el-submenu",
                    {
                      key: index,
                      staticClass: "menu_item_more",
                      attrs: { index: "" + index }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("a", [
                          _c("i", { class: "iconfont " + menu.icon }),
                          _c("span", [_vm._v(_vm._s(menu.name))])
                        ])
                      ]),
                      _vm._l(menu.children, function(child, childIndex) {
                        return _c(
                          "el-menu-item",
                          {
                            key: index + "-" + childIndex,
                            attrs: { index: index + "-" + childIndex }
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "" + child.url,
                                    target: child.target
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(child.name))])]
                              )
                            ])
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                : _c(
                    "el-menu-item",
                    {
                      key: index,
                      staticClass: "menu_item",
                      attrs: { index: "" + index }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "" + menu.url, target: menu.target }
                          },
                          [
                            _c("i", { class: "iconfont " + menu.icon }),
                            _c("span", [_vm._v(_vm._s(menu.name))])
                          ]
                        )
                      ])
                    ],
                    2
                  )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }